import { Button, HeadingRow, Treegrid } from "cai-fusion"
import { ReactComponent as IconDownload } from "../../../../../images/icon-download.svg"

import { useSiftV2 } from "../../../contexts/siftV2Context"
import { useTransientVisibility } from "../../../../fusion/Contexts/VisualContext";
import { debugLog } from "../../../../../configs/loggingConfig";

const SiftOpportunityFileBlock = () => {

    const { currOpp } = useSiftV2();
    const { show } = useTransientVisibility();

    return (
        <div className="o-block">
            <HeadingRow
                size={3}
                isSecondary
                className="l-mb-none"
                title="Documents"
                /*children={
                    <Button
                        outline
                        size="small"
                        children="Add"
                        onClick={() => show('OpportunityAddFileModal')}
                    />
                }*/
            />
            <Treegrid
                isCompact
                className="l-mr-sm"
                columnSizes={["medium", "x-small"]}
            >
                {currOpp?.request?.requestFiles?.map((file) => (
                    <tr className="o-treegrid__row o-treegrid__row--shown" key={file.id}>
                        <td className="o-treegrid_cell">
                            <span className="a-subtle-text"><strong>{file.fileName}</strong></span>
                        </td>
                        <td className="o-treegrid_cell">
                            <div className="m-icon-row m-icon-row--right-align">
                                {/* View File Button - Coming Soon */}
                                {/* Download File Button */}
                                {/*<button className="a-icon-link" onClick={() => debugLog.log("haha!")}>*/}
                                {/*    <div className="a-icon-link__inner">*/}
                                {/*        <div className="a-icon-link__icon-wrapper">*/}
                                {/*            <IconDownload className="a-icon-link__icon" />*/}
                                {/*        </div>*/}
                                {/*    </div>*/}
                                {/*</button>*/}
                                {/* Delete File Button...? */}
                            </div>
                        </td>
                    </tr>
                ))}
            </Treegrid>
        </div>
    )
}

export default SiftOpportunityFileBlock;